var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"trim-whitespace",rawName:"v-trim-whitespace"}],class:{progress: true, multi: _vm.pieces.length > 1}},_vm._l((_vm.pieces),function(piece,idx){
var _obj;
return _c('div',{directives:[{name:"trim-whitespace",rawName:"v-trim-whitespace"}],key:idx,class:( _obj = {'piece': true}, _obj[piece.color] = true, _obj ),style:(piece.style)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }